import { calculateStaffingCalendarYearOptions } from './calculate-staffing-calendar-year-options';

export const staffingCalendarYearOptions = calculateStaffingCalendarYearOptions();
